import {FormControl, InputLabel, Select, SelectProps} from "@mui/material";

export function SelectWithLabel(props: SelectProps) {
    return (
        <FormControl fullWidth={props.fullWidth}>
            <InputLabel>{props.label}</InputLabel>
            <Select {...props} />
        </FormControl>
    )
}